/* eslint-disable indent */
import PercentageCircle, {
  getPercentageCircleDefaultBandHex,
} from "@/components/shared/PercentageCircle";
import Table, { ColumeDef } from "@/components/shared/Table";
import dateFormatter from "@/helperFuntions/dateFormater";
import { Project } from "../../api/query/useProjectQuery";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Button } from "@/components/ui/button";
import CreateUpdateProjectForm from "@/components/project/CreateProjectForm";
import NoProject from "../../components/project/NoProject";
import Loader from "@/components/common/Loader";
import UserAvatar from "@/components/ui/userAvatar";
import NewEditIcon from "@/assets/v2/svg/PrimaryEdit.svg";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { ScrollText, Settings } from "lucide-react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";

import CreateProjectForm from "../../components/project/CreateProjectForm";
import {
  PlanTypeEnumSchema,
  ProjectDefaultViewEnumValue,
  ProjectStatusEnumValue,
  UserRoleEnumValue,
} from "@backend/src/schemas/enums";
import useProjectDuplicateMutation from "@/api/mutation/useDuplicateProject";
import { toast } from "react-toastify";
import TaskSubTaskForm from "@/components/tasks/taskSubTaskForm";
import DuplicateIcon from "@/assets/svg/DuplicateIcon.svg";
import Users from "@/assets/svg/Users.svg";
import { useUser } from "@/hooks/useUser";
import { errorConfig } from "@/lib/toastError";
import Dialog from "@/components/common/Dialog";
import useRemoveProjectMutation from "@/api/mutation/useProjectRemoveMutation";
import TrashCan from "@/assets/v2/svg/trash.svg";
import Plus from "@/assets/svg/NoramlPlus.svg";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { useTranslation } from "react-i18next";
import { errorKeyFormate } from "@/helperFuntions/errroMessage";
import { usePlanValidation } from "@/hooks/usePlan";
import InputText from "@/components/common/InputText";
import DeletePortfolioProgramConfirmDialog from "@/components/project/DeletePortfolioProgramConfirmDialog";
import usePortfolioUpdateMutation from "@/api/mutation/useUpdatePortfolioMutation";
import useProgramUpdateMutation from "@/api/mutation/useProgramUpdateMutaion";
import useRemoveProgramMutation from "@/api/mutation/useRemoveProgramMutaiton";
import useRemovePortfolioMutation from "@/api/mutation/useRemovePortfolioMutaiton";
import gantt from "@/assets/svg/ganttNew.svg";
import list from "@/assets/svg/listNew.svg";
import CloseCircle from "@/assets/v2/svg/primary-close-circle.svg";
import CheckedSvg from "@/assets/v2/svg/tick-circle.svg";
import GanttView from "./ganttView";
import NoFilterProject from "./noProject";
import ProjectFilter from "./projectFilter";
import { FIELDS } from "@/api/types/enums";
import dateFormater from "@/helperFuntions/dateFormater";
import Collaps from "@/assets/v2/svg/collaps.svg";
import Expand from "@/assets/v2/svg/expand.svg";
import ZoomOut from "@/assets/v2/svg/zoom-out.svg";
import ZoomIn from "@/assets/v2/svg/zoom-in.svg";
import FullScreen from "@/assets/v2/svg/full-screen.svg";
import ExitFullscreen from "@/assets/svg/ExitFullscreen.svg";
import Refresh from "@/assets/v2/svg/refresh.svg";
import * as XLSX from "xlsx";
import ExcelIcon from "@/assets/v2/svg/excel.svg";
import Select from "react-select";
import { Options } from "@/components/views/ganntView/GanttView";
import InfoCircle from "@/assets/png/information.png";
import crossNew from "@/assets/svg/crossNew.svg";
import { OrgListOfNonWorkingDaysEnum } from "@backend/src/schemas/organisationSchema";
import useProjectManagerPortfolioDashboardQuery from "@/api/query/useProjectManagerPortfolioDashboardQuery";
import {
  canDuplicateOrRemoveProject,
  canManagePortfolioHierarchyRow,
  canManageProgramHierarchyRowEnhanced,
  canManageProjectTasksAndContent,
  normalizeProjectScope,
} from "@/utils/projectRoleAccess";
import InfoProgressCircle from "@/assets/png/information.png";
import { getSpiScheduleIndicatorHex } from "@/helperFuntions/spiScheduleColor";

//================================================================
// 1. NEW HIERARCHY TYPE DEFINITIONS
//================================================================

// A project in the final hierarchy will always have these properties
export interface ProjectNode extends Project {
  type: "project";
  progress: number;
}

// A program in the final hierarchy
export interface ProgramNode {
  type: "program";
  programId: string;
  programName: string;
  progress: number;
  actualProgress: number;
  expectedProgress: number;
  portfolioId: string | undefined;
  projects: ProjectNode[];
  assignedUsers?: {
    programRole: string;
    user: {
      userId: string;
      email: string;
      firstName?: string;
      lastName?: string;
      avatarImg?: string;
    };
  }[];
}

// A portfolio in the final hierarchy
export interface PortfolioNode {
  type: "portfolio";
  portfolioId: string;
  portfolioName: string;
  progress: number;
  actualProgress: number;
  expectedProgress: number;
  projects: ProjectNode[]; // Projects directly under the portfolio
  programs: ProgramNode[];
  assignedUsers?: {
    portfolioRole: string;
    user: {
      userId: string;
      email: string;
      firstName?: string;
      lastName?: string;
      avatarImg?: string;
    };
  }[];
}

// The final data structure for your state is a union of these types
export type HierarchyItem = PortfolioNode | ProgramNode | ProjectNode;

// Internal type used during calculation to hold temporary values
type Calculable<T> = T & {
  __totalDuration: number;
  __weightedProgress: number;
  __weightedExpected: number;
};
const reactSelectStyle = {
  control: (
    provided: Record<string, unknown>,
    state: { isFocused: boolean },
  ) => ({
    ...provided,
    border: "1px solid #E7E7E7",
    paddingTop: "0rem",
    paddingBottom: "0rem",
    outline: state.isFocused ? "2px solid #535EF9" : "0px solid #E7E7E7",
    boxShadow: state.isFocused ? "0px 0px 0px #535EF9" : "none",
    "&:hover": {
      outline: "2px solid #535EF9",
      boxShadow: "0px 0px 0px #535EF9",
    },
  }),
  option: (
    provided: Record<string, unknown>,
    state: { isSelected: boolean },
  ) => ({
    ...provided,
    color: state.isSelected ? "white" : "black",
    background: state.isSelected ? "#535EF9" : "white",
    "&:hover": {
      color: "white",
      background: "#535EF999",
    },
  }),
};

//================================================================
// PROJECTS LIST COMPONENT
//================================================================

function ProjectsList() {
  const [data, setData] = useState<Project[]>();
  const [filterData, setFilterData] = useState<Project[]>();

  // State now uses the new, strongly-typed HierarchyItem
  const [hierarchyData, setHierarchyData] = useState<HierarchyItem[]>([]);

  const [isOpenPopUp, setIsOpenPopUp] = useState(false);
  const [editData, setEditData] = useState<Project | undefined>();
  const [projectId, setProjectId] = useState<string>();
  const { user } = useUser();
  const navigate = useNavigate();
  // const projectQuery = useProjectQuery(true);
  const [searchParams] = useSearchParams();
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);
  const [remove, setRemove] = useState<string>();
  const removeProjectMutation = useRemoveProjectMutation();
  const { t } = useTranslation();
  const viewOption = [
    {
      icon: list,
      view: t("list"),
      value: ProjectDefaultViewEnumValue.LIST,
    },
    {
      icon: gantt,
      view: t("rode_map"),
      value: ProjectDefaultViewEnumValue.GANTT,
    },
  ];
  const [view, setView] = useState(viewOption[1].value);
  const [loader, setLoader] = useState(true);
  useEffect(() => {
    if (user && (!user.firstName || !user.lastName)) {
      navigate("/account-settings", { state: { edit: true } });
    }
  }, [user]);

  const portfolioDashboardParams = useMemo(
    () => ({ portfolioId: "", programId: "" }),
    [],
  );
  const projectQuery = useProjectManagerPortfolioDashboardQuery(
    portfolioDashboardParams,
    true,
  );
  const projectListSearchKey = searchParams.toString();
  useEffect(() => {
    setLoader(true);
    if (!projectQuery.isFetched) {
      void projectQuery.refetch();
    }

    const raw =
      (projectQuery.data?.data.data.projects as unknown as Project[]) ?? [];
    const overallFilter = searchParams.get("overall");
    const filtered = raw.filter((project) =>
      overallFilter ? overallFilter === project.overallTrack : true,
    );
    setData(
      filtered.map((t: Project & { projectActualStartDate?: string }) => ({
        ...t,
        actualStartDate:
          t.projectActualStartDate ?? t.actualStartDate ?? "",
      })),
    );
    setLoader(false);
  }, [
    projectQuery.data?.data.data,
    projectQuery.isFetched,
    projectListSearchKey,
  ]);

  //================================================================
  // 2. NEW HIERARCHY LOGIC IMPLEMENTATION
  //================================================================

  const nonWorkingDays = useCallback(() => {
    const nWd =
      user?.userOrganisation?.map((org) => org.organisation.nonWorkingDays) ||
      [];
    const mapDayToNumber = (day: OrgListOfNonWorkingDaysEnum) => {
      switch (day) {
        case "SUN":
          return 0;
        case "MON":
          return 1;
        case "TUE":
          return 2;
        case "WED":
          return 3;
        case "THU":
          return 4;
        case "FRI":
          return 5;
        case "SAT":
          return 6;
        default:
          return 0;
      }
    };
    const result: number[] = [];
    nWd.forEach((days) => {
      days.forEach((day) => {
        result.push(mapDayToNumber(day));
      });
    });
    return result;
  }, [user]);

  const UTCDateConverter = (date: Date) => {
    return new Date(
      Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0),
    );
  };

  // Using your existing duration calculation for business logic consistency
  const calculateDurations = useCallback(
    (startDate: Date, endDate: Date): number => {
      const start = UTCDateConverter(new Date(startDate));
      const end = UTCDateConverter(new Date(endDate));

      end.setDate(end.getDate() + 1);
      const excludedDays = nonWorkingDays();
      const holidays =
        user?.userOrganisation?.[0]?.organisation?.orgHolidays?.map((h) =>
          dateFormatter(new Date(h.holidayStartDate)),
        ) ?? [];

      let duration = 0;
      for (let d = new Date(start); d < end; d.setDate(d.getDate() + 1)) {
        const day = d.getDay();
        const formattedDate = d.toISOString().split("T")[0];
        if (
          !excludedDays.includes(day) &&
          !holidays.includes(dateFormatter(new Date(formattedDate)))
        ) {
          duration++;
        }
      }
      return duration;
    },
    [user, nonWorkingDays],
  );

  /**
   * Calculates progress metrics for a single project using the component's duration logic.
   */
  const calculateProjectMetrics = useCallback(
    (project: Project) => {
      const { actualStartDate, actualEndDate, progressionPercentage } = project;
      const expectedRaw = Number((project as any).expectedprogress || 0);

      if (!actualStartDate || !actualEndDate) {
        return { duration: 0, weightedProgress: 0, progress: 0, expectedProgress: expectedRaw, weightedExpected: 0 };
      }

      const duration = calculateDurations(
        new Date(actualStartDate),
        new Date(actualEndDate),
      );
      const progress = Math.round(Number(progressionPercentage || 0) * 100);
      const weightedProgress = progress * duration;
      const weightedExpected = expectedRaw * duration;

      return { duration, weightedProgress, progress, expectedProgress: expectedRaw, weightedExpected };
    },
    [calculateDurations],
  );

  /**
   * Builds a complete project hierarchy including portfolios, orphan programs,
   * and standalone projects, with weighted progress calculated at each level.
   */
  const buildCompleteHierarchy = useCallback(
    (projectsList: Project[]): HierarchyItem[] => {
      const portfolioMap = new Map<string, Calculable<PortfolioNode>>();
      const orphanProgramMap = new Map<string, Calculable<ProgramNode>>();
      const standaloneProjects: ProjectNode[] = [];

      for (const project of projectsList) {
        if (!project.projectId) continue;

        const { duration, weightedProgress, progress, weightedExpected } =
          calculateProjectMetrics(project);
        const projectNode: ProjectNode = {
          ...project,
          type: "project",
          progress,
        };

        const hasPortfolio = !!project.portfolio?.portfolioId;
        const hasProgram = !!project.program?.programId;

        if (hasPortfolio) {
          const portfolioId = project.portfolio!.portfolioId;
          if (!portfolioMap.has(portfolioId)) {
            portfolioMap.set(portfolioId, {
              type: "portfolio",
              portfolioId,
              portfolioName:
                project.portfolio!.portfolioName || "Unnamed Portfolio",
              progress: 0,
              actualProgress: 0,
              expectedProgress: 0,
              projects: [],
              programs: [],
              assignedUsers: (project as any).portfolio?.assignedUsers,
              __totalDuration: 0,
              __weightedProgress: 0,
              __weightedExpected: 0,
            });
          }
          const portfolioEntry = portfolioMap.get(portfolioId)!;
          portfolioEntry.__totalDuration += duration;
          portfolioEntry.__weightedProgress += weightedProgress;
          portfolioEntry.__weightedExpected += weightedExpected;

          if (hasProgram) {
            const programId = project.program!.programId;
            let programEntry = portfolioEntry.programs.find(
              (p) => p.programId === programId,
            ) as Calculable<ProgramNode> | undefined;

            if (!programEntry) {
              programEntry = {
                type: "program",
                programId,
                programName: project.program!.programName || "Unnamed Program",
                progress: 0,
                actualProgress: 0,
                expectedProgress: 0,
                portfolioId: portfolioEntry.portfolioId,
                projects: [],
                assignedUsers: (project as any).program?.assignedUsers,
                __totalDuration: 0,
                __weightedProgress: 0,
                __weightedExpected: 0,
              };
              portfolioEntry.programs.push(programEntry as ProgramNode);
            }

            programEntry.__totalDuration += duration;
            programEntry.__weightedProgress += weightedProgress;
            programEntry.__weightedExpected += weightedExpected;
            programEntry.projects.push(projectNode);
          } else {
            portfolioEntry.projects.push(projectNode);
          }
        } else if (hasProgram) {
          const programId = project.program!.programId;
          if (!orphanProgramMap.has(programId)) {
            orphanProgramMap.set(programId, {
              type: "program",
              programId,
              programName: project.program!.programName || "Unnamed Program",
              progress: 0,
              actualProgress: 0,
              expectedProgress: 0,
              portfolioId: undefined,
              projects: [],
              assignedUsers: (project as any).program?.assignedUsers,
              __totalDuration: 0,
              __weightedProgress: 0,
              __weightedExpected: 0,
            });
          }
          const programEntry = orphanProgramMap.get(programId)!;
          programEntry.__totalDuration += duration;
          programEntry.__weightedProgress += weightedProgress;
          programEntry.__weightedExpected += weightedExpected;
          programEntry.projects.push(projectNode);
        } else {
          standaloneProjects.push(projectNode);
        }
      }

      const finalPortfolios = Array.from(portfolioMap.values())?.map((p) => {
        p.programs.forEach((prog) => {
          const program = prog as Calculable<ProgramNode>;
          program.progress =
            program.__totalDuration > 0
              ? Math.round(program.__weightedProgress / program.__totalDuration)
              : 0;
          program.actualProgress = program.progress;
          program.expectedProgress =
            program.__totalDuration > 0
              ? Math.round(program.__weightedExpected / program.__totalDuration)
              : 0;
          delete (program as any).__totalDuration;
          delete (program as any).__weightedProgress;
          delete (program as any).__weightedExpected;
        });
        p.progress =
          p.__totalDuration > 0
            ? Math.round(p.__weightedProgress / p.__totalDuration)
            : 0;
        p.actualProgress = p.progress;
        p.expectedProgress =
          p.__totalDuration > 0
            ? Math.round(p.__weightedExpected / p.__totalDuration)
            : 0;
        delete (p as any).__totalDuration;
        delete (p as any).__weightedProgress;
        delete (p as any).__weightedExpected;
        return p;
      });

      const finalOrphanPrograms = Array.from(orphanProgramMap.values())?.map(
        (p) => {
          p.progress =
            p.__totalDuration > 0
              ? Math.round(p.__weightedProgress / p.__totalDuration)
              : 0;
          p.actualProgress = p.progress;
          p.expectedProgress =
            p.__totalDuration > 0
              ? Math.round(p.__weightedExpected / p.__totalDuration)
              : 0;
          delete (p as any).__totalDuration;
          delete (p as any).__weightedProgress;
          delete (p as any).__weightedExpected;
          return p;
        },
      );

      return [
        ...finalPortfolios,
        ...finalOrphanPrograms,
        ...standaloneProjects,
      ];
    },
    [calculateProjectMetrics],
  );

  // 3. UPDATED useEffect TO USE THE NEW LOGIC
  useEffect(() => {
    const newData = buildCompleteHierarchy(filterData ?? []);
    setHierarchyData(newData);
  }, [filterData, buildCompleteHierarchy]);

  const close = () => {
    setIsOpenPopUp(false);
    setEditData(undefined);
    setProjectId(undefined);
  };

  const handleView = (id: string) => {
    const project = (projectQuery.data?.data.data.projects as unknown as Project[])?.find((p) => p.projectId === id);
    if (project && project.isActive === false) {
      setShowUpgradeModal(true);
      return;
    }
    navigate("/project-details/" + id);
  };

  const [isPopUpOpen, setIsPopUpOpen] = useState(false);
  const { validatePlan } = usePlanValidation();

  const handleOpenPopUp = () => {
    if (validatePlan("project").valid) {
      setIsPopUpOpen(!isPopUpOpen);
    }
  };

  const projectDuplicateMutation = useProjectDuplicateMutation();
  const createDuplicate = (id: string) => {
    if (!validatePlan("project").valid) {
      return;
    }
    projectDuplicateMutation.mutate(id, {
      onSuccess(data) {
        toast.success(data.data.message);
        projectQuery.refetch();
      },
      onError(error) {
        toast.error(
          errorKeyFormate(error.response?.data.message + ""),
          errorConfig,
        );
      },
    });
  };
  const [showInput, setShowInput] = useState("");
  const [updateValue, setUpdateValue] = useState<{
    type: "portfolio" | "program";
    id: string;
    value: string;
  }>();

  const portfolioUpdateMutation = usePortfolioUpdateMutation();
  const programUpdateMutation = useProgramUpdateMutation();
  const updatePortfolioAndProgram = () => {
    if (updateValue && updateValue.type == "portfolio" && updateValue.value) {
      portfolioUpdateMutation.mutate(
        { id: updateValue.id, value: updateValue.value },
        {
          onSuccess() {
            setUpdateValue(undefined);
            setShowInput("");
            projectQuery.refetch();
          },
          onError(error) {
            toast.error(
              errorKeyFormate(error.response?.data.message ?? ""),
              errorConfig,
            );
          },
        },
      );
    } else if (
      updateValue &&
      updateValue.type == "program" &&
      updateValue.value
    ) {
      programUpdateMutation.mutate(
        { id: updateValue.id, value: updateValue.value },
        {
          onSuccess() {
            setUpdateValue(undefined);
            setShowInput("");
            projectQuery.refetch();
          },
          onError(error) {
            toast.error(
              errorKeyFormate(error.response?.data.message ?? ""),
              errorConfig,
            );
          },
        },
      );
    } else {
      setUpdateValue(undefined);
      setShowInput("");
    }
  };
  const fullScreen = useRef<HTMLDivElement | null>(null);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [showMilestones, setShowMilestones] = useState(true);

  useEffect(() => {
    const handleFullscreenChange = () => {
      setIsFullscreen(!!document.fullscreenElement);

      const navbar = document.getElementById("navbar");
      const sidebar = document.getElementById("Sidebar");

      if (document.fullscreenElement) {
        if (navbar) navbar.classList.add("!hidden");
        if (sidebar) sidebar.classList.add("!hidden");
      } else {
        if (navbar) navbar.classList.remove("!hidden");
        if (sidebar) sidebar.classList.remove("!hidden");
      }
    };

    document.addEventListener("fullscreenchange", handleFullscreenChange);
    if (document.fullscreenElement) {
      handleFullscreenChange();
    }
    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
    };
  }, []);

  const enterFullscreen = () => {
    const elem = document.documentElement;

    if (!isFullscreen) {
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      }
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      }
    }
  };
  const [deletePortfolioAndProgram, setDeletePortfolioAndProgram] = useState<{
    portfolio: string;
    program: string;
  }>();
  const toNum = (val: any, fallback = 0) => {
    const num = parseFloat(val);
    return isFinite(num) ? num : fallback;
  };

  const projectsListDateColumnKeys = [
    "startDate",
    "actualEndDate",
    "estimatedEndDate",
    "actualEndDateDashboard",
    "recalCulatedEndDate",
  ];

  const projectsListTableClassName =
    "border-separate border-spacing-y-1 border-spacing-x-0 min-w-[max(100%,max-content)] w-full table-auto";

  const isGroupHierarchyRow = (row: { type?: string }) =>
    row?.type === "portfolio" || row?.type === "program";

  const groupRowCell = (
    <span className="text-base font-medium text-gray-400">-</span>
  );

  const scheduleIndicatorDelayRange = {
    onTimeDelayMax:
      user?.userOrganisation?.[0]?.organisation?.onTimeDelayMax ?? 5,
    moderateDelayMax:
      user?.userOrganisation?.[0]?.organisation?.moderateDelayMax ?? 20,
  };

  // 4. COLUMN DEFINITION UPDATED TO HANDLE NEW DATA STRUCTURE
  const columnDef: ColumeDef[] = [
    {
      key: "projectName",
      header: t("project_name"),
      sorting: true,
      width: 260,
      colspan: () => 1,
      onCellRender: (item: HierarchyItem) => {
        return (
          <div className="w-full flex items-center justify-between gap-2">
            {item.type === "project" && (
              <div className={`text-left truncate ${(item as any)?.portfolioportfolioId && (item as any)?.programprogramId ? "max-w-36" : (item as any)?.portfolioportfolioId || (item as any)?.programprogramId ? "" : ""}`}>                {item.isActive ? (
                <TooltipProvider delayDuration={0}>
                  <Tooltip>
                    <TooltipTrigger asChild>
                      <Link
                        className="text-primary-500 underline "
                        to={
                          user?.subscription?.planType ==
                            PlanTypeEnumSchema.FREE || !user?.subscription
                            ? `/tasks/${item.projectId}`
                            : `/projectDashboard/${item.projectId}`
                        }
                      >
                        {item.projectName}
                      </Link>
                    </TooltipTrigger>
                    <TooltipContent>{item.projectName}</TooltipContent>
                  </Tooltip>
                </TooltipProvider>
              ) : (
                <TooltipProvider delayDuration={0}>
                  <Tooltip>
                    <TooltipTrigger asChild>
                      <div className="flex items-center gap-2">
                        <img src={CloseCircle} className="w-5 max-w-5" />
                        <div className={`truncate w-32 `}>
                          {item.projectName}
                        </div>
                      </div>
                    </TooltipTrigger>
                    <TooltipContent>{item.projectName}</TooltipContent>
                  </Tooltip>
                </TooltipProvider>
              )}
              </div>
            )}

            {item.type === "program" ? (
              <div className=" max-w-[20rem]">
                {showInput == item.programId ? (
                  <div className="flex gap-2 items-center">
                    <InputText
                      className="mt-0 my-2 h-[40px]"
                      defaultValue={item.programName ?? ""}
                      onKeyDown={(e) =>
                        e.key == "Enter" ? updatePortfolioAndProgram() : ""
                      }
                      onChange={(e) => {
                        const val = e.target.value;
                        setUpdateValue({
                          type: "program",
                          id: item.programId,
                          value: val,
                        });
                      }}
                    />
                    <span
                      className={` cursor-pointer `}
                      onClick={(e) => {
                        e.stopPropagation();
                        updatePortfolioAndProgram();
                      }}
                    >
                      <img src={CheckedSvg} className="w-5 max-w-5" />
                    </span>
                    <span
                      className={`font-bold text-sm text-red-400 cursor-pointer `}
                      onClick={(e) => {
                        e.stopPropagation();
                        setUpdateValue(undefined);
                        setShowInput("");
                      }}
                    >
                      <img src={CloseCircle} className="w-5 max-w-5" />
                    </span>
                  </div>
                ) : (
                  <div className="flex gap-2 items-center">
                    <div className="h-14 flex items-center truncate ">
                      {item.programName}
                    </div>
                    {user &&
                      canManageProgramHierarchyRowEnhanced(user, item.programId, item.portfolioId) && (
                        <div className="row-action-buttons flex gap-1 items-center">
                          <img
                            src={NewEditIcon}
                            className=" h-4.5 w-4.5 w-4 cursor-pointer"
                            onClick={(e) => {
                              e.stopPropagation();
                              setShowInput(item.programId);
                            }}
                          />
                          <img
                            src={TrashCan}
                            className="mr-2 h-4.5 w-4.5 w-4 cursor-pointer"
                            onClick={(e) => {
                              e.stopPropagation();
                              setDeletePortfolioAndProgram({
                                portfolio: "",
                                program: item.programId,
                              });
                            }}
                          />
                        </div>
                      )}
                  </div>
                )}
              </div>
            ) : item.type === "portfolio" ? (
              <div className=" max-w-[26rem]">
                {showInput == item.portfolioId ? (
                  <div className="flex gap-2 items-center">
                    <InputText
                      className="mt-0 my-2 h-[40px]"
                      defaultValue={item.portfolioName ?? ""}
                      onKeyDown={(e) =>
                        e.key == "Enter" ? updatePortfolioAndProgram() : ""
                      }
                      onChange={(e) => {
                        const val = e.target.value;
                        setUpdateValue({
                          type: "portfolio",
                          id: item.portfolioId,
                          value: val,
                        });
                      }}
                    />
                    <span
                      className={` cursor-pointer `}
                      onClick={(e) => {
                        e.stopPropagation();
                        updatePortfolioAndProgram();
                      }}
                    >
                      <img src={CheckedSvg} className="w-5 max-w-5" />
                    </span>
                    <span
                      className={`font-bold text-xs text-red-400 cursor-pointer `}
                      onClick={(e) => {
                        e.stopPropagation();
                        setUpdateValue(undefined);
                        setShowInput("");
                      }}
                    >
                      <img src={CloseCircle} className="w-5 max-w-5" />
                    </span>
                  </div>
                ) : (
                  <div className="flex gap-2 items-center">
                    <div className="h-14 flex items-center !truncate ">
                      {item.portfolioName}
                    </div>
                    {user &&
                      canManagePortfolioHierarchyRow(user, item.portfolioId) && (
                        <div className="row-action-buttons flex gap-1 items-center">
                          <img
                            src={NewEditIcon}
                            className="h-4.5 w-4.5  w-4 cursor-pointer"
                            onClick={(e) => {
                              e.stopPropagation();
                              setShowInput(item.portfolioId);
                            }}
                          />
                          <img
                            src={TrashCan}
                            className="mr-2 h-4.5 w-4.5  w-4 cursor-pointer"
                            onClick={(e) => {
                              e.stopPropagation();
                              setDeletePortfolioAndProgram({
                                portfolio: item.portfolioId,
                                program: "",
                              });
                            }}
                          />
                        </div>
                      )}
                  </div>
                )}
              </div>
            ) : (
              ""
            )}
          </div>
        );
      },
    },
    {
      key: "createdByUser",
      header: t("Manager"),
      width: 100,
      onCellRender: (item: HierarchyItem) => {
        if (item.type == "project") {
          const userPm = item.assignedUsers?.find((u) => {
            return u?.projectRole == UserRoleEnumValue.PROJECT_MANAGER;
          });
          return userPm ? (
            <TooltipProvider>
              <Tooltip>
                <TooltipTrigger asChild>
                  <div className="ml-3 flex">
                    <div>
                      <UserAvatar
                        className="shadow-sm shadow-gray-300 border-2 border-white"
                        user={userPm?.user}
                      />
                    </div>
                  </div>
                </TooltipTrigger>
                <TooltipContent>
                  <div className="text-sm space-y-0.5">
                    <div>
                      {t("Role")}: {t((userPm?.projectRole || "").toLowerCase())}
                    </div>
                    {userPm?.user.firstName && userPm?.user.lastName && (
                      <div>
                        {t("name")}:{" "}
                        {`${userPm?.user.firstName} ${userPm?.user.lastName}`}
                      </div>
                    )}
                    <div>
                      {t("Email")}: {userPm?.user.email}
                    </div>
                  </div>
                </TooltipContent>
              </Tooltip>
            </TooltipProvider>
          ) : (
            groupRowCell
          );
        } else if (item.type == "portfolio") {
          const portfolioManager = item.assignedUsers?.[0];
          return portfolioManager ? (
            <TooltipProvider>
              <Tooltip>
                <TooltipTrigger asChild>
                  <div className="ml-3 flex">
                    <div>
                      <UserAvatar
                        className="shadow-sm shadow-gray-300 border-2 border-white"
                        user={portfolioManager?.user}
                      />
                    </div>
                  </div>
                </TooltipTrigger>
                <TooltipContent>
                  <div className="text-sm space-y-0.5">
                    <div>
                      {t("Role")}:{" "}
                      {t(
                        (portfolioManager?.portfolioRole || "").toLowerCase(),
                      )}
                    </div>
                    {portfolioManager?.user.firstName &&
                      portfolioManager?.user.lastName && (
                        <div>
                          {t("name")}:{" "}
                          {`${portfolioManager?.user.firstName} ${portfolioManager?.user.lastName}`}
                        </div>
                      )}
                    <div>
                      {t("Email")}: {portfolioManager?.user.email}
                    </div>
                  </div>
                </TooltipContent>
              </Tooltip>
            </TooltipProvider>
          ) : (
            groupRowCell
          );
        } else if (item.type == "program") {
          const programManager = item.assignedUsers?.[0];
          return programManager ? (
            <TooltipProvider>
              <Tooltip>
                <TooltipTrigger asChild>
                  <div className="ml-3 flex">
                    <div>
                      <UserAvatar
                        className="shadow-sm shadow-gray-300 border-2 border-white"
                        user={programManager?.user}
                      />
                    </div>
                  </div>
                </TooltipTrigger>
                <TooltipContent>
                  <div className="text-sm space-y-0.5">
                    <div>
                      {t("Role")}:{" "}
                      {t((programManager?.programRole || "").toLowerCase())}
                    </div>
                    {programManager?.user.firstName &&
                      programManager?.user.lastName && (
                        <div>
                          {t("Name")}:{" "}
                          {`${programManager?.user.firstName} ${programManager?.user.lastName}`}
                        </div>
                      )}
                    <div>
                      {t("Email")}: {programManager?.user.email}
                    </div>
                  </div>
                </TooltipContent>
              </Tooltip>
            </TooltipProvider>
          ) : (
            groupRowCell
          );
        }
        return groupRowCell;
      },
    },
    {
      key: "progressionPercentage",
      header: t("Actual Progress"),
      width: 118,

      sorting: true,
      onCellRender: (item: HierarchyItem) => {
        if (isGroupHierarchyRow(item)) {
          const groupItem = item as PortfolioNode | ProgramNode;
          return (
            <div>
              <PercentageCircle
                percentage={groupItem.actualProgress ?? 0}
              />
            </div>
          );
        }
        const spiColor = getSpiScheduleIndicatorHex(
          item.type === "project" ? item.spi : undefined,
          scheduleIndicatorDelayRange,
        );

        return (
          <div>
            <PercentageCircle
              percentage={Number((item as any)?.progressionPercentage) * 100} // Use the calculated progress for all types
              roundColor={spiColor}
            />
          </div>
        );
      },
    },
    {
      key: "expectedprogress",
      header: t("Expacted Progress"),
      width: 128,
      sorting: true,
      onCellRender: (item: Project) => {
        if (isGroupHierarchyRow(item as HierarchyItem)) {
          const groupItem = item as unknown as PortfolioNode | ProgramNode;
          const actualPct = groupItem.actualProgress ?? 0;
          return (
            <div>
              <PercentageCircle
                percentage={Math.min(groupItem.expectedProgress ?? 0, 100)}
                roundColor={getPercentageCircleDefaultBandHex(actualPct)}
              />
            </div>
          );
        }
        const spiColor = getSpiScheduleIndicatorHex(
          item.spi,
          scheduleIndicatorDelayRange,
        );

        return (
          <div>
            <PercentageCircle
              percentage={Math.min(toNum(Number(item.expectedprogress), 0), 100)} // Use the calculated progress for all types
              roundColor={spiColor}
            />
          </div>
        );
      },
    },
    {
      key: "status",
      header: t("status"),
      width: 100,
      sorting: true,
      onCellRender: (item: HierarchyItem) =>
        item.type === "project" ? (
          <>
            <div
              className={`w-24 h-8 px-3 py-1.5 ${getStatusColor(
                item.status,
              )} rounded-full justify-center items-center gap-px inline-flex`}
            >
              <div className=" text-xs font-medium leading-tight">
                {t(item.status)
                }
              </div>
            </div>
          </>
        ) : (
          groupRowCell
        ),
    },
    {
      key: "spi",
      header: t("spi"),
      width: 100,
      sorting: true,
      onCellRender: (item: Project) =>
        isGroupHierarchyRow(item as HierarchyItem) ? (
          groupRowCell
        ) : (
        <div className="flex gap-1  items-center">
          {item.spi ? item.spi.toFixed() : (0).toFixed()}%
          <img
            src={InfoCircle}
            className="min-w-4 w-4 brightness-0 invert"
            alt="InfoCircle"
          />
        </div>
        ),
      onHeaderRender: (item: string) => (
        <>
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger className="flex gap-1  items-center">
                {t(item)}
                <img
                  src={InfoProgressCircle}
                  className="min-w-4 w-4"
                  alt="InfoCircle"
                />
              </TooltipTrigger>
              <TooltipContent className="" sideOffset={30}>
                <p className="text-sm w-auto h-full text-left text-nowrap  !z-[9999]">
                  <div
                    dangerouslySetInnerHTML={{
                      __html: t("spi_tooltip", {
                        lowThreshold:
                          100 -
                          (user?.userOrganisation?.[0]?.organisation
                            ?.moderateDelayMax ?? 20),
                        midThreshold:
                          100 -
                          (user?.userOrganisation?.[0]?.organisation
                            ?.onTimeDelayMax ?? 5),
                        highThreshold: 100,
                        percentage:
                          user?.userOrganisation?.[0]?.organisation
                            ?.moderateDelayMax ?? 20,
                      }),
                    }}
                  ></div>
                </p>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        </>
      ),
    },
    {
      key: "cpi",
      header: t("cpi"),
      width: 100,
      sorting: true,
      onCellRender: (item: Project) =>
        isGroupHierarchyRow(item as HierarchyItem) ? (
          groupRowCell
        ) : (
        <>
          <div className="flex gap-1 items-center w-fit">
            {item.cpi ? item.cpi.toFixed() : (0).toFixed()}%
            <img
              src={InfoCircle}
              className="min-w-4 w-4 brightness-0 invert"
              alt="InfoCircle"
            />
          </div>
        </>
        ),
      onHeaderRender: (item: string) => (
        <>
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger className="flex gap-1 items-center w-fit">
                {t(item)}
                <img
                  src={InfoProgressCircle}
                  className="min-w-4 w-4"
                  alt="InfoCircle"
                />
              </TooltipTrigger>
              <TooltipContent className="z-50" sideOffset={30}>
                <p className="text-sm  w-auto  text-left text-wrap">
                  <div
                    dangerouslySetInnerHTML={{
                      __html: t("CPI_description", {
                        lowThreshold:
                          100 -
                          (user?.userOrganisation?.[0]?.organisation
                            ?.moderateBudgetMax ?? 20),
                        midThreshold:
                          100 -
                          (user?.userOrganisation?.[0]?.organisation
                            ?.onBudgetMax ?? 5),
                        highThreshold: 100,
                        percentage:
                          user?.userOrganisation?.[0]?.organisation
                            ?.moderateBudgetMax ?? 20,
                      }),
                    }}
                  ></div>
                </p>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        </>
      ),
    },
    {
      key: "startDate",
      header: t("estimated_start_date"),
      sorting: true,
      width: 132,
      onCellRender: (item: HierarchyItem) =>
        item.type === "project" ? (
          <div className="text-base font-medium whitespace-nowrap tabular-nums">
            {dateFormatter(new Date(item.startDate))}
          </div>
        ) : (
          groupRowCell
        ),
    },
    {
      key: "actualEndDate",
      header: t("actual_date"),
      sorting: true,
      width: 120,
      onCellRender: (item: HierarchyItem) =>
        item.type === "project" ? (
          <>
            {item.actualEndDate ? (
              <div className="text-base font-medium whitespace-nowrap tabular-nums">
                {dateFormatter(new Date(item.actualEndDate))}
              </div>
            ) : (
              <div className="text-base font-medium whitespace-nowrap">N/A</div>
            )}
          </>
        ) : (
          groupRowCell
        ),
    },
    {
      key: "estimatedEndDate",
      header: t("estimated_end_date"),
      sorting: true,
      width: 132,
      onCellRender: (item: HierarchyItem) =>
        item.type === "project" ? (
          <>
            {item.estimatedEndDate ? (
              <div className="text-base font-medium whitespace-nowrap tabular-nums">
                {dateFormatter(new Date(item.estimatedEndDate))}
              </div>
            ) : (
              <div className="text-base font-medium whitespace-nowrap">N/A</div>
            )}
          </>
        ) : (
          groupRowCell
        ),
    },

    {
      key: "actualEndDateDashboard",
      header: t("actual_end_date"),
      sorting: false,
      width: 128,
      onCellRender: (item: HierarchyItem) => {
        if (isGroupHierarchyRow(item)) return groupRowCell;
        const p = item as Project;
        return (
          <>
            {p.actualEndDate ? (
              <div className="text-base font-medium whitespace-nowrap tabular-nums">
                {dateFormater(new Date(p.actualEndDate))}
              </div>
            ) : (
              <div className="text-base font-medium whitespace-nowrap">N/A</div>
            )}
          </>
        );
      },
    },
    {
      key: "recalCulatedEndDate",
      header: t("Re_calculated_end_date"),
      sorting: true,
      width: 148,
      onCellRender: (item: HierarchyItem) => {
        if (isGroupHierarchyRow(item)) return groupRowCell;
        const p = item as Project;
        return (
          <>
            {p.reCalculateEndDate ? (
              <div className="text-base font-medium whitespace-nowrap tabular-nums">
                {dateFormater(new Date(p.reCalculateEndDate))}
              </div>
            ) : (
              <div className="text-base font-medium whitespace-nowrap">N/A</div>
            )}
          </>
        );
      },
    },
    {
      key: "estimatedBudget",
      header: t("estimated_budget"),
      sorting: true,
      width: 128,
      onCellRender: (item: HierarchyItem) =>
        isGroupHierarchyRow(item) ? (
          groupRowCell
        ) : (
        <>
          {(item as Project).estimatedBudget !== undefined &&
            !isNaN(Number((item as Project).estimatedBudget))
            ? Math.round(Number((item as Project).estimatedBudget))
            : 0}
        </>
        ),
    },
    {
      key: "consumedBudget",
      header: t("consumed_budget"),
      sorting: true,
      width: 128,
      onCellRender: (item: HierarchyItem) =>
        isGroupHierarchyRow(item) ? (
          groupRowCell
        ) : (
        <>
          {(item as Project).consumedBudget !== undefined &&
            !isNaN(Number((item as Project).consumedBudget))
            ? Math.round(Number((item as Project).consumedBudget))
            : 0}
        </>
        ),
    },
    {
      key: "reCalculateBudget",
      header: t("Re_calculated_budget"),
      sorting: true,
      width: 140,
      onCellRender: (item: HierarchyItem) =>
        isGroupHierarchyRow(item) ? (
          groupRowCell
        ) : (
        <>
          {(item as Project).reCalculateBudget !== undefined &&
            !isNaN(Number((item as Project).reCalculateBudget))
            ? Math.round(Number((item as Project).reCalculateBudget))
            : 0}
        </>
        ),
    },
    {
      key: "Action",
      header: t("actions"),
      width: 100,
      onCellRender: (item: HierarchyItem) => {
        if (item.type !== "project") return groupRowCell;

        const findUser = item?.assignedUsers?.find(
          (t: { user: { userId: string | undefined } }) =>
            t.user.userId == user?.userId,
        );

        const projectNode = item as ProjectNode;
        const canManageThisProject = Boolean(
          user &&
            canManageProjectTasksAndContent(
              user,
              user.userOrganisation[0]?.role,
              projectNode.assignedUsers,
              normalizeProjectScope(projectNode),
            ),
        );
        const canDuplicateOrRemoveThisProject = Boolean(
          user &&
            canDuplicateOrRemoveProject(
              user,
              user.userOrganisation[0]?.role,
              projectNode.assignedUsers,
              normalizeProjectScope(projectNode),
            ),
        );

        return (
          <>
            <DropdownMenu>
              <DropdownMenuTrigger
                asChild
                disabled={
                  !item.isActive ||
                  (findUser &&
                    findUser.projectRole == UserRoleEnumValue.COLLABORATOR &&
                    !canManageThisProject)
                }
                className={`${!item.isActive ||
                  (findUser &&
                    findUser.projectRole == UserRoleEnumValue.COLLABORATOR &&
                    !canManageThisProject)
                  ? "opacity-65"
                  : ""
                  }`}
              >
                <div
                  className={`cursor-pointer  px-3 py-1.5 bg-transparent justify-center items-center gap-px inline-flex ${!item.isActive ? "cursor-not-allowed" : ""
                    }`}
                >
                  <img src={NewEditIcon} className="mr-2 h-4 w-4" />
                </div>
              </DropdownMenuTrigger>
              <DropdownMenuContent className="w-fit flex flex-col gap-1">
                <DropdownMenuSeparator className="mx-1" />
                <DropdownMenuItem onClick={() => handleView(item.projectId)}>
                  <Settings className="mr-2 h-4 w-4 text-[#44546F]" />
                  <span className="p-0 font-normal h-auto">
                    {t("project_settings")}
                  </span>
                </DropdownMenuItem>
                <DropdownMenuItem
                  disabled={
                    findUser?.projectRole == UserRoleEnumValue.TEAM_MEMBER &&
                    !canManageThisProject
                  }
                  onClick={() => setProjectId(item.projectId)}
                >
                  <ScrollText className="mr-2 h-4 w-4 text-[#44546F]" />
                  <span className="p-0 font-normal h-auto">
                    {t("create_task")}
                  </span>
                </DropdownMenuItem>
                <DropdownMenuItem
                      onClick={() => {
                        if (canDuplicateOrRemoveThisProject) {
                          createDuplicate(item.projectId);
                        }
                      }}
                      disabled={!canDuplicateOrRemoveThisProject}
                      className={!canDuplicateOrRemoveThisProject ? "opacity-50 cursor-not-allowed" : ""}
                    >
                      <img src={DuplicateIcon} className="h-4 w-4 mr-2" />
                      <span className="p-0 font-normal h-auto">
                        {t("duplicate_project")}
                      </span>
                    </DropdownMenuItem>
                <DropdownMenuItem
                  onClick={() => navigate("/members/" + item.projectId)}
                >
                  <img src={Users} className="h-4 w-4 mr-2" />
                  <span className="p-0 font-normal h-auto">
                    {t("project_members")}
                  </span>
                </DropdownMenuItem>
                <DropdownMenuItem 
                      onClick={() => {
                        if (canDuplicateOrRemoveThisProject) {
                          setRemove(item.projectId);
                        }
                      }}
                      disabled={!canDuplicateOrRemoveThisProject}
                      className={!canDuplicateOrRemoveThisProject ? "opacity-50 cursor-not-allowed" : ""}
                    >
                      <img src={TrashCan} className="h-4 w-4 mr-2" />
                      <span className="p-0 font-normal h-auto text-red-500">
                        {t("remove_project")}
                      </span>
                    </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
          </>
        );
      },
    },
  ];

  const getStatusColor = (status: string) => {
    switch (status) {
      case ProjectStatusEnumValue.NOT_STARTED:
        return "bg-[#FF8C00]/20 text-[#FF8C09]";
      case ProjectStatusEnumValue.ON_HOLD:
        return "bg-[#FAB415]/20 text-[#B58109]";
      case ProjectStatusEnumValue.ACTIVE:
      case ProjectStatusEnumValue.IN_PROGRESS:
        return "bg-[#53C36C]/20 text-[#15803D]";
      case ProjectStatusEnumValue.CLOSED:
      case ProjectStatusEnumValue.COMPLETED:
        return "bg-[#828F9B]/20 text-[#828F89]";
      case ProjectStatusEnumValue.CANCELLED:
        return "bg-[#EF4444]/20 text-[#DC2626]";
    }
  };

  const removeProject = () => {
    removeProjectMutation.mutate(remove ?? "", {
      onSuccess(data) {
        toast.success(data.data.message);
        projectQuery.refetch();
        setRemove(undefined);
      },
      onError(error) {
        toast.error(errorKeyFormate(error.response?.data.message + ""));
      },
    });
  };

  const removeProgramMutation = useRemoveProgramMutation();
  const removePortfolioMutation = useRemovePortfolioMutation();
  const handleRemovePortfolioAndProgram = () => {
    if (deletePortfolioAndProgram?.portfolio) {
      removePortfolioMutation.mutate(deletePortfolioAndProgram?.portfolio, {
        onSuccess() {
          projectQuery.refetch().then(() => {
            setDeletePortfolioAndProgram(undefined);
            projectQuery.refetch();
          });
        },
        onError(error) {
          toast.error(
            errorKeyFormate(error.response?.data.message ?? ""),
            errorConfig,
          );
        },
      });
    }
    if (deletePortfolioAndProgram?.program) {
      removeProgramMutation.mutate(deletePortfolioAndProgram?.program, {
        onSuccess() {
          projectQuery.refetch().then(() => {
            setDeletePortfolioAndProgram(undefined);
            projectQuery.refetch();
          });
        },
        onError(error) {
          toast.error(
            errorKeyFormate(error.response?.data.message ?? ""),
            errorConfig,
          );
        },
      });
    }
  };
  const innerTable = (data: any, level = 0) => {
    return (
      <div className="w-full min-w-0">
        <Table
          expandAll={Boolean(searchParams.size) || isExpand}
          key="Project view"
          hideHeaders={true}
          tableClassName={`${projectsListTableClassName} !shadow-none`}
            columnDef={
            columnDef?.map((d) => {
              return {
                ...d,
                className: () => {
                  const isDateCol = projectsListDateColumnKeys.includes(d.key);
                  const pad = isDateCol ? "px-3 py-2.5" : "px-3 py-2.5";
                  if (level == 0) {
                    return `${d.key === "Action" ? "rounded-e-xl" : ""} ${
                      d.key === "projectName" ? "!max-w-96" : ""
                    } ${pad} align-middle`.trim();
                  }
                  return `${pad} align-middle`;
                },
              };
            }) ?? []
          }
          className="border-0 !px-0 !rounded-none [&>*]:!overflow-hidden"
          data={[
            ...(Array.isArray(data.programs) ? data.programs : []),
            ...(Array.isArray(data.projects) ? data.projects : []),
          ]}
          onAccordionRender={(data) =>
            [
              ...(Array.isArray(data.programs) ? data.programs : []),
              ...(Array.isArray(data.projects) ? data.projects : []),
            ].length > 0 ? (
              innerTable(data, level + 1)
            ) : (
              <></>
            )
          }
          onRowClassName={(data) => {
            return `row-action-hover-group ${data.type === "project" && !data.isActive
              ? "opacity-70 cursor-not-allowed  "
              : ""
              } ${data.type === "portfolio"
                ? "!bg-secondary/20 !border-none "
                : ""
              }  border-b  ${data.type === "program" ? "!bg-secondary/10 !border-none " : ""
              }`;
          }}
          showDropDown={(data) => {
            return `${data.type === "project" ? "opacity-0 !pl-0" : ""
              } !pl-0 !rounded-s-xl`;
          }}
          showDropDownImg={() => {
            return "!block";
          }}
          hidePagination={true}
          notShowNoDataFound={true}
        />
      </div>
    );
  };
  const [isOpenWorkLoad, setIsOpenWorkLoad] = useState(false);
    const downloadExcel = () => {
      const projectSorted = [
        ...(data?.filter((p: any) => !p.portfolio && !p.program) ?? []),
        ...(data?.filter((p: any) => p.portfolio || p.program) ?? []),
      ];
      const rows = buildRows(projectSorted ?? []);

      const worksheet = XLSX.utils.json_to_sheet(rows, {
        skipHeader: false,
      });

      applyStyles(worksheet, rows);

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Portfolio");

      XLSX.writeFile(workbook, "portfolio.xlsx");
    };
    const INDENT_PROGRAM = "    "; // 4 spaces
    const INDENT_PROJECT = "        "; // 8 spaces

    const applyStyles = (worksheet: any, rows: any[]) => {
      rows.forEach((_, i) => {
        const cell = worksheet[`A${i + 2}`];
        if (!cell?.v) return;

        // Portfolio
        if (!cell.v.startsWith(" ")) {
          cell.s = {
            font: { bold: true, sz: 12 },
            fill: { fgColor: { rgb: "FFF59D" } },
          };
        }

        // Program
        if (cell.v.startsWith(INDENT_PROGRAM)) {
          cell.s = {
            font: { bold: true },
          };
        }
      });
    };
    const projectRow = (p: any, programName: string) => {
        // Use same formulas and rounding as UI so export matches screen (e.g. 55.65 → 56)
        const actualRaw = Number(p.progressionPercentage ?? 0) * 100;
        const actualProgress = Math.round(actualRaw);
        const spi = Number(p.spi ?? 0);
        // Same as UI: (progressionPercentage * 100) / (spi/100), then round (do not use rounded actual)
        const expectedProgress = Math.min(
          spi > 0 ? Math.round(actualRaw / (spi / 100)) : actualProgress,
          100
        );
        return {
          [t("project_name")]:
            `${programName ? INDENT_PROJECT : ""}${p.projectName}`,
          [t("Actual Progress")]: `${actualProgress}%`,
          [t("Expacted Progress")]: `${expectedProgress}%`,
          [t("status")]: p.status
            ?.toLowerCase()
            .replace(/_/g, " ")
            .replace(/\b\w/g, (c: string) => c.toUpperCase()),
          [t("spi")]: `${Math.round(Number(p.spi ?? 0))}%`,
          [t("cpi")]: `${Math.round(Number(p.cpi ?? 0))}%`,
          [t("estimated_start_date")]: dateFormater(new Date(p.startDate)),
          [t("actual_start_date")]: dateFormater(
            new Date(p.projectActualStartDate),
          ),
          [t("estimated_end_date")]: dateFormater(new Date(p.estimatedEndDate)),
          [t("actual_end_date")]: dateFormater(new Date(p.actualEndDate)),
          [t("Re_calculated_end_date")]: p.reCalculateEndDate
            ? dateFormater(new Date(p.reCalculateEndDate))
            : "N/A",
          [t("estimated_budget")]: p.estimatedBudget,
          [t("consumed_budget")]: p.consumedBudget,
          [t("Re_calculated_budget")]:
            p.reCalculateBudget != null
              ? Math.round(Number(p.reCalculateBudget))
              : 0,
        };
      };
    const buildRows = (projects: any[]) => {
      const rows: any[] = [];

      // Group by portfolio
      const portfolioMap = new Map<string | null, any[]>();

      projects.forEach((p) => {
        const key = p.portfolio?.portfolioId ?? "NO_PORTFOLIO";
        if (!portfolioMap.has(key)) portfolioMap.set(key, []);
        portfolioMap.get(key)!.push(p);
      });

      portfolioMap.forEach((portfolioProjects, portfolioKey) => {
        const portfolioName =
          portfolioKey !== "NO_PORTFOLIO"
            ? portfolioProjects[0].portfolio.portfolioName
            : "";

        if (portfolioName) {
          rows.push({
            [t("project_name")]: portfolioName,
          });
        }

        // Group by program
        const programMap = new Map<string | null, any[]>();

        portfolioProjects.forEach((p) => {
          const key = p.program?.programId ?? "NO_PROGRAM";
          if (!programMap.has(key)) programMap.set(key, []);
          programMap.get(key)!.push(p);
        });

        programMap.forEach((programProjects, programKey) => {
          const programName =
            programKey !== "NO_PROGRAM"
              ? programProjects[0].program.programName
              : "";

          if (programName) {
            rows.push({
              [t("project_name")]: `${INDENT_PROGRAM}${programName}`,
            });
          }

          // 🟢 Projects
          programProjects.forEach((project) => {
            rows.push(projectRow(project, programName));
          });
        });
      });

      // Remove empty rows (rows with empty or missing project_name)
      return rows?.filter((row) => {
        const projectName = row[t("project_name")];
        return projectName != null && String(projectName).trim() !== "";
      });
    };

  const [isExpand, setIsExpand] = useState(Boolean(searchParams.size) ?? true);
  const [filterUnit, setFilterUnit] = useState(1);
  const [selectedDateType, setSelectedDateType] = useState<
    "estimated" | "actual"
  >("estimated");
  const [compare, setCompare] = useState<
    "estimatedToActual" | "actualToReCalculated" | "all" | ""
  >("");
  const options = [
    {
      label: t("Estimated Dates"),
      value: "estimated",
      tooltip: t("Estimated dates tooltip"),
    },
    {
      label: t("Current Dates"),
      value: "actual",
      tooltip: t("Current dates tooltip"),
    },
  ];
  const [isShowVideo, setIsShowVideo] = useState(false);

  // Remaining JSX of your component is here...
  // ... No changes needed for the rest of the file
  const navigtae = useNavigate();
  const toggleWorkload = () => {
    if (
      !user?.subscription ||
      !user?.subscription?.planType ||
      user?.subscription?.planType == PlanTypeEnumSchema.FREE
    ) {
      navigtae("/plans");
    } else {
      setIsOpenWorkLoad(!isOpenWorkLoad);
    }
  };
  if (projectQuery.isFetched && data && data.length == 0) {
    return <NoProject />;
  }
  return (
    <div
      className="relative flex h-full min-h-0 w-full flex-col overflow-hidden"
      ref={fullScreen}
    >

      <>
        <div className="flex h-full min-h-0 w-full flex-1 flex-col gap-2 overflow-hidden px-2 pt-2 pb-0">
          <div className="flex w-full shrink-0 items-center justify-between">
            <div className="flex gap-2 items-end">
              <ProjectFilter
                key={searchParams.size}
                project={data}
                fieldToShow={[
                  FIELDS.STATUS,
                  FIELDS.DELAY,
                  FIELDS.DATE,
                  FIELDS.BUDGET,
                ]} // adjust as needed
                filteredData={(data) => setFilterData(data || [])}
                appleed={() => {
                  if (filterData) {
                    setLoader(false);
                  }
                }}
              />
              <Button
                variant={"primary"}
                className="w-fit flex gap-1 ml-full text-white !bg-gradient-to-r !from-[#535EF9] !to-[#3B82F6] hover:!from-[#535EF9]/90 hover:!to-[#3B82F6]/90 shadow-[0_4px_12px_-2px_rgba(83,94,249,0.3)] border-0"
                size={"sm"}
                onClick={handleOpenPopUp}
                disabled={
                  !(
                    user?.userOrganisation[0]?.role ===
                      UserRoleEnumValue.ADMINISTRATOR ||
                    (user?.managedPortfolioIds &&
                      user.managedPortfolioIds.length > 0) ||
                    (user?.managedProgramIds &&
                      user.managedProgramIds.length > 0)
                  )
                }
              >
                <img
                  src={Plus}
                  className="w-3 min-w-3 brightness-0 invert "
                />
                {t("add_project")}
              </Button>
            </div>
            {view == ProjectDefaultViewEnumValue.GANTT && (
              <Button
                variant={"link"}
                onClick={() => setIsShowVideo(true)}
                className="text-secondary underline underline-offset-2 text-sm ml-auto h-fit !p-0 mr-2 "
              >
                {t("Check the video")}
              </Button>
            )}
            <div className="flex items-center justify-around gap-1 bg-[#F3F4F6] rounded-full px-2 py-1 w-fit">
              {viewOption?.map((item) => {
                return (
                  <TooltipProvider key={item.value}>
                    <Tooltip delayDuration={0}>
                      <TooltipTrigger asChild>
                        <div className="flex-1">
                          <button
                            className={`text-gra rounded-full min-w-14 relative flex items-center justify-center px-3 py-[0.6rem] h-fit gap-2 text-sm text-nowrap ${item.value == view
                              ? "bg-orange text-white"
                              : "bg-[#F3F4F6] text-[#565D6D]"
                              }`}
                            onClick={() => {
                              setView(item.value);
                            }}
                          >
                            <img src={item.icon} className={`w-4 min-w-4 ${item.value == view ? "brightness-0 invert" : "grayscale brightness-0"}`} />
                            {t(
                              item.value == ProjectDefaultViewEnumValue.GANTT
                                ? "roadmap_view"
                                : "List View",
                            )}
                          </button>
                        </div>
                      </TooltipTrigger>
                      <TooltipContent>
                        <p className="text-sm">
                          {t(
                            item.value == ProjectDefaultViewEnumValue.GANTT
                              ? "roadmap_view"
                              : "List View",
                          )}
                        </p>
                      </TooltipContent>
                    </Tooltip>
                  </TooltipProvider>
                );
              })}
            </div>
          </div>

          <div className="flex w-full shrink-0 items-center justify-between px-2">
            <div className="flex gap-1 items-center">
              <TooltipProvider>
                <Tooltip>
                  <TooltipTrigger asChild>
                    <li className="list-none">
                      <Button
                        variant={"none"}
                        onClick={() => setIsExpand(!isExpand)}
                        size={"sm"}
                      >
                        <img
                          src={!isExpand ? Collaps : Expand}
                          alt=""
                          className="w-4 min-w-4"
                        />
                      </Button>
                    </li>
                  </TooltipTrigger>
                  <TooltipContent className="bg-white rounded-md px-2 py-1.5 shadow-lg border border-gray-450/30">
                    <p className="text-sm">
                      {t(!isExpand ? "expand" : "collapse")}
                    </p>
                  </TooltipContent>
                </Tooltip>
              </TooltipProvider>
              {view == ProjectDefaultViewEnumValue.GANTT && (
                <TooltipProvider>
                  <Tooltip>
                    <TooltipTrigger asChild>
                      <li className="list-none">
                        <Button
                          variant={"none"}
                          className="select-none"
                          disabled={filterUnit == 0}
                          onClick={() =>
                            setFilterUnit((prev) => prev - 1)
                          }
                          size={"sm"}
                        >
                          <img src={ZoomIn} className="w-4 min-w-4" />
                        </Button>
                      </li>
                    </TooltipTrigger>
                    <TooltipContent>
                      <p className="text-sm">{t("zoomin")}</p>
                    </TooltipContent>
                  </Tooltip>
                </TooltipProvider>
              )}
              {view == ProjectDefaultViewEnumValue.GANTT && (
                <TooltipProvider>
                  <Tooltip>
                    <TooltipTrigger asChild>
                      <li className="list-none">
                        <Button
                          variant={"none"}
                          className="select-none"
                          disabled={filterUnit == 4}
                          onClick={() =>
                            setFilterUnit((prev) => prev + 1)
                          }
                          size={"sm"}
                        >
                          <img src={ZoomOut} className="w-4 min-w-4" />
                        </Button>
                      </li>
                    </TooltipTrigger>
                    <TooltipContent>
                      <p className="text-sm">{t("zoomout")}</p>
                    </TooltipContent>
                  </Tooltip>
                </TooltipProvider>
              )}
              <TooltipProvider>
                <Tooltip>
                  <TooltipTrigger asChild>
                    <li className="list-none">
                      <Button
                        variant={"none"}
                        className="select-none"
                        onClick={() => enterFullscreen()}
                        size={"sm"}
                      >
                        <img
                          src={
                            !isFullscreen ? FullScreen : ExitFullscreen
                          }
                          className="w-4 min-w-4"
                        />
                      </Button>
                    </li>
                  </TooltipTrigger>
                  <TooltipContent className="bg-white rounded-md px-2 py-1.5 shadow-lg border border-gray-450/30">
                    <p className="text-sm">
                      {t(
                        !isFullscreen
                          ? "full_Screen"
                          : "full_exit_screen",
                      )}
                    </p>
                  </TooltipContent>
                </Tooltip>
              </TooltipProvider>
              <TooltipProvider>
                <Tooltip delayDuration={0}>
                  <TooltipTrigger asChild>
                    <li className="list-none">
                      <Button
                        variant={"none"}
                        className="select-none"
                        onClick={() => projectQuery.refetch()}
                        size={"sm"}
                      >
                        <img src={Refresh} className="w-4 min-w-4" />
                      </Button>
                    </li>
                  </TooltipTrigger>
                  <TooltipContent className="bg-white rounded-md px-2 py-1.5 shadow-lg border border-gray-450/30">
                    <p className="text-sm">{t("reload")}</p>
                  </TooltipContent>
                </Tooltip>
              </TooltipProvider>
              <div>
                <Button
                  variant={"none"}
                  className=" !p-2"
                  onClick={() => downloadExcel()}
                  size={"sm"}
                >
                  <img src={ExcelIcon} className="w-4 min-w-4" />
                </Button>
              </div>
              <div className="flex items-center ml-1">
                <TooltipProvider>
                  <Tooltip>
                    <TooltipTrigger asChild>
                      <label className="flex items-center gap-1 cursor-pointer select-none">
                        <input
                          type="checkbox"
                          checked={showMilestones}
                          onChange={(e) => setShowMilestones(e.target.checked)}
                          className="w-3.5 h-3.5 rounded border-gray-300 text-orange focus:ring-orange cursor-pointer"
                        />
                        <span className="text-xs font-medium text-gray-600">{t("milestone")}</span>
                      </label>
                    </TooltipTrigger>
                  </Tooltip>
                </TooltipProvider>
              </div>
              {view == ProjectDefaultViewEnumValue.GANTT && (
                <Button
                  variant={
                    isOpenWorkLoad ? "primary" : "primary_outline"
                  }
                  onClick={() => toggleWorkload()}
                  className="h-fit text-xs py-1 hidden"
                  size={"sm"}
                >
                  {t("Work load")}
                </Button>
              )}
            </div>

            <div className="flex justify-between pl-4 mt-2 items-center ">
              <div className="flex items-center gap-3 text-sm font-medium">

                <div className="flex items-center justify-between">

                  {view == ProjectDefaultViewEnumValue.GANTT && (
                    <div className="flex gap-2">
                      <div className="flex gap-4">
                        {options?.map((option) => (
                          <label
                            key={option.value}
                            className="flex items-center space-x-2 relative"
                          >
                            <input
                              type="radio"
                              name="dateType"
                              value={option.value}
                              checked={selectedDateType === option.value}
                              onChange={() => {
                                setSelectedDateType(
                                  option.value as "estimated" | "actual",
                                );
                                setCompare("");
                              }}
                              className="form-radio text-blue-600"
                            />
                            <span>{option.label}</span>
                            <TooltipProvider>
                              <Tooltip>
                                <TooltipTrigger className="flex gap-1 items-center absolute -top-2.5 -right-2">
                                  <img
                                    src={InfoCircle}
                                    className="h-[14px] w-[14px] "
                                    alt="InfoCircle"
                                  />
                                </TooltipTrigger>
                                <TooltipContent>
                                  <p className="text-sm text-center w-96">
                                    {option.tooltip}
                                  </p>
                                </TooltipContent>
                              </Tooltip>
                            </TooltipProvider>
                          </label>
                        ))}
                      </div>
                      <Select
                        key={compare}
                        className="p-0 w-80"
                        options={[
                          {
                            label: t("Compare schedules"),
                            value: "",
                          },
                          {
                            label: (
                              <div className="flex w-full items-center justify-between">
                                {" "}
                                {t("Estimated VS Actual schedule")}{" "}
                                <TooltipProvider>
                                  <Tooltip>
                                    <TooltipTrigger className="flex gap-1 items-center">
                                      <img
                                        src={InfoCircle}
                                        className="h-[14px] w-[14px]"
                                        alt="InfoCircle"
                                      />
                                    </TooltipTrigger>
                                    <TooltipContent>
                                      <p className="text-sm text-center w-96">
                                        {t("Current dates tooltip")}
                                      </p>
                                    </TooltipContent>
                                  </Tooltip>
                                </TooltipProvider>
                              </div>
                            ),
                            value: "estimatedToActual",
                          },
                          {
                            label: (
                              <div className="flex w-full items-center justify-between">
                                {" "}
                                {t("Actual VS Recalculated schedule")}{" "}
                                <TooltipProvider>
                                  <Tooltip>
                                    <TooltipTrigger className="flex gap-1 items-center">
                                      <img
                                        src={InfoCircle}
                                        className="h-[14px] w-[14px]"
                                        alt="InfoCircle"
                                      />
                                    </TooltipTrigger>
                                    <TooltipContent>
                                      <p className="text-sm text-center w-96">
                                        {t("Recalculated schedule tooltip")}
                                      </p>
                                    </TooltipContent>
                                  </Tooltip>
                                </TooltipProvider>
                              </div>
                            ),
                            value: "actualToReCalculated",
                          },
                          {
                            label: t("Compare All"),
                            value: "all",
                          },
                        ]}
                        defaultValue={[
                          {
                            label: t("Compare schedules"),
                            value: "",
                          },
                          {
                            label: (
                              <div className="flex w-full items-center justify-between">
                                {" "}
                                {t("Estimated VS Actual schedule")}{" "}
                                <TooltipProvider>
                                  <Tooltip>
                                    <TooltipTrigger className="flex gap-1 items-center">
                                      <img
                                        src={InfoCircle}
                                        className="h-[14px] w-[14px]"
                                        alt="InfoCircle"
                                      />
                                    </TooltipTrigger>
                                    <TooltipContent>
                                      <p className="text-sm text-center !w-96 text-wrap">
                                        {t("Current dates tooltip")}
                                      </p>
                                    </TooltipContent>
                                  </Tooltip>
                                </TooltipProvider>
                              </div>
                            ),
                            value: "estimatedToActual",
                          },
                          {
                            label: (
                              <div className="flex w-full items-center justify-between">
                                {" "}
                                {t("Actual VS Recalculated schedule")}{" "}
                                <TooltipProvider>
                                  <Tooltip>
                                    <TooltipTrigger className="flex gap-1 items-center">
                                      <img
                                        src={InfoCircle}
                                        className="h-[14px] w-[14px]"
                                        alt="InfoCircle"
                                      />
                                    </TooltipTrigger>
                                    <TooltipContent>
                                      <p className="text-sm text-center !w-96 text-wrap">
                                        {t("Recalculated schedule tooltip")}
                                      </p>
                                    </TooltipContent>
                                  </Tooltip>
                                </TooltipProvider>
                              </div>
                            ),
                            value: "actualToReCalculated",
                          },
                          {
                            label: t("Compare All"),
                            value: "all",
                          },
                        ].find((t) => t.value == compare)}
                        onChange={(e: any) => {
                          const val = e as Options;
                          if (val && val.value) {
                            setCompare(
                              val.value as
                              | "estimatedToActual"
                              | "actualToReCalculated"
                              | "all",
                            );
                            setSelectedDateType("estimated");
                          } else {
                            setCompare("");
                          }
                          if (val.value == "actualToReCalculated") {
                            setSelectedDateType("actual");
                          }
                        }}
                        placeholder={t("Compare schedules")}
                        styles={reactSelectStyle}
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="relative flex min-h-0 w-full flex-1 flex-col">
            {(loader || projectQuery.isRefetching || projectQuery.isFetching) ? (
              <Loader className="absolute top-0 left-0 z-50 w-full h-full bg-white" />
            ) : (
              <div className="flex h-full min-h-0 w-full min-w-0 flex-col">
                {view == ProjectDefaultViewEnumValue.LIST &&
                  <div className="flex min-h-0 w-full min-w-0 flex-1 flex-col overflow-hidden">
                    {filterData && filterData.length && (
                      <Table
                        tableClassName={projectsListTableClassName}
                        key={hierarchyData.length}
                        expandAll={isExpand}
                        hederClassName="!bg-[#E4E6EB] shadow-[inset_0_-1px_0_0_rgba(0,0,0,0.06)] [&_th]:!px-3 [&_th]:!py-3.5 [&_th]:text-[13px] [&_th]:font-semibold [&_th]:text-gray-800 [&_th]:whitespace-normal [&_th]:leading-snug [&_th]:align-middle"
                        columnDef={
                          columnDef?.map((d) => {
                            const isDateCol = projectsListDateColumnKeys.includes(
                              d.key,
                            );
                            return {
                              ...d,
                              className: () => {
                                return `${d.key === "Action" ? "rounded-e-xl" : ""
                                  } ${isDateCol ? "px-3 py-2.5" : "px-2.5 py-2"} align-middle`.trim();
                              },
                            };
                          }) ?? []
                        }
                        data={hierarchyData}
                        className="h-full min-h-0 w-full min-w-0 flex flex-col !rounded-lg !border !border-gray-200/90 !shadow-sm"
                        onAccordionRender={(data) => innerTable(data)}
                        onRowClassName={(data) => {
                          return `row-action-hover-group ${data.type === "project" && !data.isActive
                            ? "opacity-70 cursor-not-allowed !border-b "
                            : ""
                            } ${data.type === "portfolio" ? "!bg-secondary/20" : ""
                            } ${data.type === "program" ? "!bg-secondary/10" : ""}`;
                        }}
                        showDropDown={(data) => {
                          return `${data.type === "project" ? "opacity-0 !pl-0 " : "!pl-0"
                            } !rounded-s-xl`;
                        }}
                        showDropDownArrow={(data) => {
                          return `${data.type === "project" ? "opacity-0 !pl-0 " : "!pl-0"
                            }`;
                        }}
                        notShowNoDataFound={true}
                      />
                    )}
                    {!data && (
                      <div className="flex justify-center p-3 w-full">
                        {t("no_projects_available")}
                      </div>
                    )}
                  </div>}
                {view == ProjectDefaultViewEnumValue.GANTT &&
                  (!projectQuery.isRefetching || projectQuery.isFetched) &&
                  filterData &&
                  filterData?.length > 0 && (
                    <div className="flex min-h-0 w-full min-w-0 flex-1 flex-col overflow-hidden">
                      <GanttView
                        key={projectQuery.status + filterData.length}
                        projects={filterData ?? []}
                        setFilterUnit={setFilterUnit}
                        FilterUnit={filterUnit}
                        expandAll={isExpand}
                        selectedDateType={selectedDateType}
                        compare={compare}
                        showMilestones={showMilestones}
                        setSelectedDateType={setSelectedDateType}
                        hierarchyData={hierarchyData}
                        isOpenWorkLoad={isOpenWorkLoad}
                      />
                    </div>
                  )}
                {filterData &&
                  filterData.length == 0 &&
                  data &&
                  data.length > 0 && <NoFilterProject />}
              </div>

            )}
          </div>
        </div>



        {isOpenPopUp && (
          <CreateUpdateProjectForm
            handleClosePopUp={close}
            editData={editData}
            key={projectId}
          />
        )}
        {projectId && (
          <TaskSubTaskForm
            taskId={undefined}
            projectId={projectId}
            close={close}
          />
        )}
        <style>{`
          .row-action-hover-group .row-action-buttons {
            display: none !important;
          }
          .row-action-hover-group:hover .row-action-buttons {
            display: flex !important;
          }
        `}</style>
      </>
      {isPopUpOpen && <CreateProjectForm handleClosePopUp={handleOpenPopUp} />}
      <Dialog
        isOpen={Boolean(remove)}
        onClose={() => setRemove(undefined)}
        modalClass="rounded-lg"
      >
        <div className="flex flex-col gap-2 p-6 ">
          <img src={TrashCan} className="w-12 m-auto" />{" "}
          {t("common_delete_message")}
          <div className="flex gap-2 ml-auto">
            <Button
              variant={"outline"}
              isLoading={removeProjectMutation.isPending}
              disabled={removeProjectMutation.isPending}
              onClick={() => setRemove(undefined)}
            >
              {t("cancel")}
            </Button>
            <Button
              variant={"primary"}
              className="text-white"
              onClick={removeProject}
            >
              {t("delete")}
            </Button>
          </div>
        </div>
      </Dialog>
      <DeletePortfolioProgramConfirmDialog
        isOpen={Boolean(
          deletePortfolioAndProgram?.portfolio ||
          deletePortfolioAndProgram?.program,
        )}
        isPortfolio={!!deletePortfolioAndProgram?.portfolio}
        isLoading={
          removePortfolioMutation.isPending ||
          removeProgramMutation.isPending
        }
        trashIcon={TrashCan}
        onClose={() => setDeletePortfolioAndProgram(undefined)}
        onConfirm={handleRemovePortfolioAndProgram}
      />
      {isShowVideo && (
        <Dialog
          isOpen={isShowVideo}
          onClose={() => { }}
          modalClass="rounded-lg h-[90%] w-[85%] py-4 flex flex-col overflow-hidden relative"
        >
          <div
            className="mt-3 mr-5 justify-end shadow-sm  absolute top-2 right-2 z-50 rounded-full p-3 bg-gray-500/30"
            onClick={() => setIsShowVideo(false)}
          >
            <img
              src={crossNew}
              className="w-5 min-5 brightness-0 cursor-pointer"
            />
          </div>
          <div className="relative w-full h-full">
            <iframe
              src="https://player.vimeo.com/video/1083552233?h=f6ba6f65f9&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479&amp;autoplay=1"
              allowFullScreen
              allow="autoplay; fullscreen; picture-in-picture; clipboard-write"
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
              }}
              title="ProjectChef Demo"
            ></iframe>
          </div>
        </Dialog>
      )}
      {showUpgradeModal && (
        <Dialog
          isOpen={showUpgradeModal}
          onClose={() => setShowUpgradeModal(false)}
          modalClass="rounded-lg "
          bgClass="!backdrop-blur-sm"
        >
          <div className="flex flex-col gap-4 p-6 w-96 text-center">
            {(!user?.userOrganisation[0]?.role ||
              user?.userOrganisation[0]?.role ==
                UserRoleEnumValue.COLLABORATOR) ? (
              t("You do not have access to this dashboard with your current plan. Please contact your administrator to upgrade the current plan")
            ) : (
              t("Project dashboard are not available in this plan. Do you want to upgrade your plan?")
            )}
            <div className="flex gap-2 ml-auto">
              {(!user?.userOrganisation[0]?.role ||
                user?.userOrganisation[0]?.role ==
                  UserRoleEnumValue.COLLABORATOR) ? (
                <Button
                  variant={"outline"}
                  onClick={() => {
                    setShowUpgradeModal(false);
                  }}
                >
                  {t("ok")}
                </Button>
              ) : (
                <>
                  <Button
                    variant={"outline"}
                    onClick={() => {
                      setShowUpgradeModal(false);
                    }}
                  >
                    {t("cancel")}
                  </Button>
                  <Button
                    variant={"primary"}
                    className="text-white"
                    onClick={() => {
                      navigate("/plans");
                    }}
                  >
                    {t("Upgrade")}
                  </Button>
                </>
              )}
            </div>
          </div>
        </Dialog>
      )}
    </div>
  );
}

export default ProjectsList;
